import React from 'react';
import { Handshake, Users, TrendingUp, ShieldCheck, Globe2, GraduationCap } from 'lucide-react';
import PageHero, { Section, InfoCard, CTABlock } from '../components/PageHero';

const timeline = [
  { year: '1947', title: 'Diplomatic Relations Established', desc: 'India and USSR formally established diplomatic ties on 13 April 1947, months before India’s independence.' },
  { year: '1971', title: 'Treaty of Peace & Friendship', desc: 'The landmark Indo-Soviet Treaty solidified strategic cooperation in defence, trade and culture.' },
  { year: '1993', title: 'Post-Soviet Renewal', desc: 'India and the Russian Federation signed a new Treaty of Friendship & Cooperation to continue the partnership.' },
  { year: '2000', title: 'Strategic Partnership', desc: 'Elevated to a “Strategic Partnership” during President Putin’s visit to India.' },
  { year: '2010', title: 'Special & Privileged Strategic Partnership', desc: 'The India-Russia relationship gained a unique global status — shared by very few countries.' },
  { year: '2024', title: '75+ Years of Friendship', desc: 'Continued cooperation on defence, energy, education, space and technology sectors.' },
];

const areas = [
  { icon: ShieldCheck, title: 'Defence Cooperation', desc: 'Russia has been India’s largest defence partner for decades — fighter jets, submarines, and joint tech development.' },
  { icon: TrendingUp, title: 'Trade & Energy', desc: 'Growing bilateral trade in oil, LNG, pharmaceuticals, precious stones, and consumer goods.' },
  { icon: GraduationCap, title: 'Education & Exchange', desc: '15,000+ Indian students study in Russia every year — mostly in medicine, engineering and technology.' },
  { icon: Globe2, title: 'Space & Science', desc: 'Joint missions with ISRO/Roscosmos including the Gaganyaan crewed spaceflight training partnership.' },
];

export default function Relations() {
  return (
    <>
      <PageHero eyebrow="75+ Years of Friendship" title="India – Russia" highlight="Relations"
        subtitle="One of the most enduring bilateral relationships in the modern world — spanning defence, energy, education, culture, and space."
        breadcrumbs={[{ label: 'India – Russia Relations' }]} />

      <Section eyebrow="Timeline" title="Milestones in" highlight="the Partnership">
        <div className="relative pl-4 md:pl-8 border-l-2 border-brand/25 space-y-6">
          {timeline.map((t, i) => (
            <div key={i} className="relative">
              <div className="absolute -left-[26px] md:-left-[42px] w-6 h-6 rounded-full bg-brand text-white flex items-center justify-center text-[10px] font-bold">{i+1}</div>
              <div className="bg-white rounded-2xl p-5 border border-border shadow-sm">
                <div className="flex items-center gap-3 mb-2">
                  <span className="font-serif text-2xl font-bold text-brand">{t.year}</span>
                  <h4 className="font-serif text-lg font-bold text-primary">{t.title}</h4>
                </div>
                <p className="text-sm text-muted-foreground">{t.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </Section>

      <Section eyebrow="Key Sectors" title="Areas of" highlight="Cooperation" muted>
        <div className="grid sm:grid-cols-2 gap-5">
          {areas.map((a, i) => <InfoCard key={i} icon={a.icon} title={a.title}>{a.desc}</InfoCard>)}
        </div>
      </Section>

      <CTABlock title="Be part of the education bridge" subtitle="Study MBBS in Russia — backed by 75+ years of trusted friendship." />
    </>
  );
}
